import axios from "axios";
import { jsError } from "../../common/utils";

const LOCALIZATION_API_URL = import.meta.env.VITE_LOCALIZATION_API_URL ?? "http://localhost:8083";

const localizationServiceClient = axios.create({
  baseURL: LOCALIZATION_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const localizationServerGet = (url) => {
  return localizationServiceClient.get(url).catch(function (error) {
    if (error.response) {
      // Request made and server responded
      jsError(error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      jsError(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      jsError("localizationServerGet Error", error.message);
    }
    return {};
  });
};

export const localizationServerPost = (url, payload) => {
  return localizationServiceClient.post(url, payload).catch(function (error) {
    if (error.response) {
      // Request made and server responded
      jsError(error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      jsError(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      jsError("localizationServerPost Error", error.message);
    }
    return {};
  });
};
